import {
  MAX_PREVIEW_ROWS,
  PHONE_COLUMN,
  SENDER_COLUMN,
} from '../constants/whatsapp';
import type { CsvRow } from '../types/whatsapp';

const cellClass = 'whitespace-nowrap px-4 py-2 text-xs text-gray-700';
const headerClass =
  'px-4 py-2 text-left text-xs font-medium uppercase text-gray-500';

interface SheetPreviewTableProps {
  rows: CsvRow[];
  variableNumbers: number[];
}

export default function SheetPreviewTable({
  rows,
  variableNumbers,
}: SheetPreviewTableProps) {
  const columnNames = [
    PHONE_COLUMN,
    SENDER_COLUMN,
    ...variableNumbers.map(String),
  ];
  const shown = rows.slice(0, MAX_PREVIEW_ROWS);

  return (
    <div>
      <h4 className="mb-2 text-sm font-medium text-gray-700">
        How we read your sheet
      </h4>
      <div className="overflow-x-auto rounded-md border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className={headerClass}>#</th>
              {columnNames.map((columnName) => (
                <th key={columnName} className={headerClass}>
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {shown.map((row) => (
              <tr key={row.lineNumber}>
                <td className={`${cellClass} text-gray-500`}>
                  {row.lineNumber}
                </td>
                {columnNames.map((columnName) => (
                  <td key={columnName} className={cellClass}>
                    {row.cells[columnName]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows.length > MAX_PREVIEW_ROWS && (
        <p className="mt-1 text-xs text-gray-500">
          Showing {MAX_PREVIEW_ROWS} of {rows.length} rows.
        </p>
      )}
    </div>
  );
}
